import {computed} from 'vue'
import {
  ThemeType,
} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'
import {useCurrentThemeType} from '@toolify/client/src/modules/theme/composables/useCurrentThemeType'
import {useLightModernAppearance} from '@toolify/client/src/modules/theme/composables/useLightModernAppearance'
import {
  LightModernPaletteVariantType,
} from '@toolify/server/src/services/UserSettingsService/strategies/LightModernPaletteVariantUserSettingStrategy/enum/LightModernPaletteVariantType'
import {LightModernSidebarVariantType} from '@toolify/client/src/modules/theme/enum/LightModernSidebarVariantType'
import {IThemeAttributes} from '@toolify/client/src/modules/theme/types/IThemeAttributes'

// Atrybuty motywu dla <html> (App.vue) i dla elementow, ktore ustawiaja motyw same:
//   <div v-bind="themeAttributes">  zamiast  <div :data-theme="currentTheme">
// Atrybuty strojenia light-modern (data-lm-*) czyta tylko light-modern - w pozostalych motywach ich nie ma
export function useThemeAttributes() {
  const {currentThemeType} = useCurrentThemeType()
  const {paletteVariant} = useLightModernAppearance()

  const isLightModernThemeActive = computed(() => currentThemeType.value === ThemeType.LightModern)

  // Komplet dla dowolnego motywu (np. kafel podgladu motywu w Ustawieniach -> Wyglad) z paleta light z konta;
  // kafel wyboru palety podaje wlasna
  function getThemeAttributes(themeType: ThemeType, lightModernPaletteVariant?: LightModernPaletteVariantType): IThemeAttributes {
    if (themeType !== ThemeType.LightModern) {
      return {
        'data-theme': themeType,
      }
    }
    return {
      'data-theme': themeType,
      'data-lm-sidebar': LightModernSidebarVariantType.Contrast,
      'data-lm-palette': lightModernPaletteVariant ?? paletteVariant.value,
    }
  }

  const themeAttributes = computed<IThemeAttributes>(() => getThemeAttributes(currentThemeType.value))

  return {
    currentThemeType,
    isLightModernThemeActive,
    themeAttributes,
    getThemeAttributes,
  }
}
